
var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.AjaxFetchApiRequest = new Class({
    Extends: OCS.Classes.AjaxAbstractRequest,
    class_name: "AjaxFetchApiRequest",
    options: {
        cache: 'default',
        mode: 'same-origin',
        credentials: 'include',
        redirect: 'manual',
        referrer: 'client',
        headers: {
            'Accept': 'text/javascript, text/html, application/xml, text/xml, application/json, */*'
        }
    },
    response: null,
    request: null,
    initialize: function (options) {
        if (options && options.mode !== 'cors') {
            options.corsRequest = false;
        }
        this.parent(options);
        this.headers = this.options.headers;
        if (!this.options.corsRequest) {
            Object.append(this.headers, {'X-Requested-With': 'XMLHttpRequest'});
        }

        // Enforce no cache
        if (this.options.cache === 'no-cache' || this.options.noCache) {
            this.options.noCache = true;
            this.options.cache = 'no-cache';
        }
        if (this.options.corsRequest) {
            this.options.mode = 'cors';
        }

    },
    getHeader: function (name) {

    },
    send: function (options) {
        if (!this.check(options))
            return this;

        this.options.isSuccess = this.options.isSuccess || this.isSuccess;
        this.running = true;

        // Use fetch and request api
        var myRequest = this.get_request(options);
        fetch(myRequest).then(this.onStateChange.bind(this));
        if (this.getThenableState() !== 'pending') {
            this.resetThenable({reason: 'send'});
        }
        this.fireEvent('request');

        return this;
    },
    onStateChange: function (response) {
        this.running = false;
        this.status = 0;
        Function.attempt(function () {
            var status = response.status;
            this.status = (status === 1223) ? 204 : status;
        }.bind(this));

        if (this.timer) {
            clearTimeout(this.timer);
            delete this.timer;
        }

        this.response = {"request": this};
        if (this.options.responseType && (this.options.responseType === 'arraybuffer' || this.options.responseType === 'blob' || this.options.responseType === 'json')) {
            if (this.options.responseType === 'blob') {
                this.response[this.options.responseType] = response.blob();
            }
            if (this.options.responseType === 'arraybuffer') {
                this.response[this.options.responseType] = response.arrayBuffer();
            }
            if (this.options.responseType === 'json') {
                this.response[this.options.responseType] = response.json();
            }
        } else {
            if (!this.options.responseType) {
                this.response.text = response.text() || '';
            }
        }

        if (this.options.isSuccess.call(this, this.status))
            this.success(this.response);
        else
            this.failure();

    },
    get_request: function (options) {
        var type = typeOf(options);
        if (type === 'string' || type === 'element')
            options = {data: options};

        var old = this.options;
        options = Object.append({data: old.data, url: old.url, method: old.method}, options);
        var data = options.data;
        var method = options.method.toLowerCase();

        if (!this.request) {
            var url = String(options.url);
            if (this.options.urlEncoded && ['post', 'put'].contains(method)) {
                var encoding = (this.options.encoding) ? '; charset=' + this.options.encoding : '';
                this.headers['Content-type'] = 'application/x-www-form-urlencoded' + encoding;
            }

            url = this.url_string_replace(url);


            var trimPosition = url.lastIndexOf('/');
            if (trimPosition > -1 && (trimPosition = url.indexOf('#')) > -1)
                url = url.substr(0, trimPosition);

            if (this.options.noCache)
                url += (url.indexOf('?') > -1 ? '&' : '?') + String.uniqueID();

            if (data && (method === 'get' || method === 'delete')) {
                url += (url.indexOf('?') > -1 ? '&' : '?') + data;
                data = null;
            }


            var myHeaders = new Headers(this.headers);
            var myInit = {
                method: method.toUpperCase(),
                headers: myHeaders,
                mode: this.options.mode,
                cache: this.options.cache,
                credentials: this.options.credentials,
                redirect: this.options.redirect,
                referrer: this.options.referrer
            };

            this.set_request(new Request(url, myInit));
        }

        // Deal with the incoming options
        switch (typeOf(data)) {
            case 'object':
            case 'hash':
                data = Object.toQueryString(data);
        }

        if (this.options.format) {
            var format = 'format=' + this.options.format;
            data = (data) ? format + '&' + data : format;
        }

        if (this.options.emulation && !['get', 'post'].contains(method)) {
            var _method = '_method=' + method;
            data = (data) ? _method + '&' + data : _method;
            method = 'post';
        }


        if (data && this.request.method !== 'GET' && this.request.method !== 'HEAD') {
            this.request.body = data;
        }


        return this.request;
    },
    set_request: function (request) {
        this.request = request;
    },
    processScripts: function (text) {
        return text;
    },
    get_response: function () {
        return this.response;
    },
    cancel: function () {

    }
});
